<div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-28"   >
  <div>
    <label>{{ 'committees.edit.committee-meetings.from-this-date' | translate | ucfirst }}</label>
    <wl-date-selector [(ngModel)]="searchParams.FromDate"></wl-date-selector>
  </div>
  <div>
    <label>{{ 'committees.edit.committee-meetings.to-this-date' | translate | ucfirst }}</label>
    <wl-date-selector [(ngModel)]="searchParams.ToDate"></wl-date-selector>
  </div>
</div>
